// extracted by mini-css-extract-plugin
export default {"Placeholder14Wrap":"MobileAndVerifyForm_Placeholder14Wrap__BVh23","EmailRegister":"MobileAndVerifyForm_EmailRegister__YaQPn"};